export namespace S25Bootstrap {
    // bootstrap 4 break points
    // https://v4-alpha.getbootstrap.com/layout/overview/
    /**
     * // Extra small devices (portrait phones, less than 576px)
     // No media query since this is the default in Bootstrap

     // Small devices (landscape phones, 576px and up)
     @media (min-width: 576px) { ... }

      // Medium devices (tablets, 768px and up)
     @media (min-width: 768px) { ... }

      // Large devices (desktops, 992px and up)
     @media (min-width: 992px) { ... }

      // Extra large devices (large desktops, 1200px and up)
     @media (min-width: 1200px) { ... }
     */
    export const breakpoints = {
        // note: our breakpoints are shift-by-one because bootstrap breaks columns on prev point
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1200,
    };

    export function getColMaxWidth(
        point: keyof typeof breakpoints,
        numCols: number,
        maxWidth?: number,
    ): number | undefined {
        if (!point || !numCols) {
            return undefined;
        }

        const screenWidth = window.screen.width;
        const colWidth = Math.ceil(screenWidth / numCols);
        const ptWidth = breakpoints[point];

        // largest from (colWidth, ptWidth) but no more than screenWidth
        const bootstrapWidth = Math.min(screenWidth, Math.max(colWidth, ptWidth || 0));

        // if maxWidth provided use it
        return Math.min(maxWidth || Number.MAX_VALUE, bootstrapWidth);
    }
}
